var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('table-top-head'),_c('div',{staticClass:"single-page-con"},[_c('div',{staticClass:"single-page"},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }